import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
const Contact = ({ settings, lang }) => {
    const getText = (en, ar) => (lang === "en" ? en : ar);
    const getStatic = (key, fallback) => {
        const staticData = lang === "en" ? settings.en : settings.ar;
        return (staticData && staticData[key]) ? staticData[key] : fallback;
    }

    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };

    useEffect(() => {
        document.title = getStatic("page_title_contact", "إينوبريدج - تواصل معنا");

        // Update meta description
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
            metaDesc.setAttribute("content", getStatic("meta_description_contact", "إينوبريدج - عنا"));
        }

        // Update meta keywords
        const metaKeywords = document.querySelector("meta[name='keywords']");
        if (metaKeywords) {
            metaKeywords.setAttribute("content", getStatic("meta_keyword_contact", "إينوبريدج - عنا"));
        }
    }, [lang, settings]);

    const [formStatus, setFormStatus] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Placeholder for contact form submission logic
        setFormStatus("success");
        setTimeout(() => setFormStatus(null), 3000);
        e.target.reset();
    };

    return (
        <>
            <header className="py-5 bg-body header header1">
                <div className="container py-5 text-center">
                    <div className="layout-h"></div>
                    <h1 className="display-4 fw-bold mb-3" data-aos="fade-up">
                        {getStatic("contact_title", "Contact Us")}
                    </h1>
                    <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }} data-aos="zoom-in" data-aos-delay="100">
                        {getStatic("contact_desc", "We'd love to hear from you...")}
                    </p>
                </div>
            </header>

            <section className="py-5 bg-card">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-5" data-aos="fade-right">
                            <div className="card-custom h-100">
                                <h3 className="fw-bold mb-4">{getText("Get in Touch", "تواصل معنا")}</h3>
                                <div className="d-flex gap-3 mb-4">
                                    <div className="text-primary"><i className="ri-map-pin-line fs-4"></i></div>
                                    <div>
                                        <h5 className="fw-bold mb-1">{getText("Headquarters", "المقر الرئيسي")}</h5>
                                        <p className="text-muted mb-0">{getText("123 Innovation Dr, New York, NY 10001", "123 طريق الابتكار، نيويورك، نيويورك 10001")}</p>
                                    </div>
                                </div>
                                <div className="d-flex gap-3 mb-4">
                                    <div className="text-primary"><i className="ri-mail-line fs-4"></i></div>
                                    <div>
                                        <h5 className="fw-bold mb-1">{getText("Email", "البريد الإلكتروني")}</h5>
                                        <p className="text-muted mb-0">info@innobridge.com</p>
                                    </div>
                                </div>
                                <div className="d-flex gap-3 mb-4">
                                    <div className="text-primary"><i className="ri-phone-line fs-4"></i></div>
                                    <div>
                                        <h5 className="fw-bold mb-1">{getText("Phone", "الهاتف")}</h5>
                                        <p className="text-muted mb-0">+1 212 555 0123</p>
                                    </div>
                                </div>
                                <hr className="my-4" />
                                <h5 className="fw-bold mb-3">{getText("Our Locations", "مواقعنا")}</h5>
                                <p className="text-muted mb-3">{getText("Find our offices around the world.", "اعثر على مكاتبنا حول العالم.")}</p>
                                <Link to="/map" className="btn btn-outline-custom w-100">
                                    {getText("View Interactive Map", "عرض الخريطة التفاعلية")}
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-7" data-aos="fade-left">
                            <div className="card-custom">
                                <h3 className="fw-bold mb-4">{getText("Send us a Message", "أرسل لنا رسالة")}</h3>
                                <form onSubmit={handleSubmit}>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label">{getText("Name", "الاسم")}</label>
                                            <input type="text" className="form-control bg-card" required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">{getText("Email", "البريد الإلكتروني")}</label>
                                            <input type="email" className="form-control bg-card" required />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label">{getText("Subject", "الموضوع")}</label>
                                            <input type="text" className="form-control bg-card" required />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label">{getText("Message", "الرسالة")}</label>
                                            <textarea className="form-control bg-card" rows="5" required></textarea>
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="btn btn-primary-custom">
                                                {getText("Send Message", "إرسال الرسالة")}
                                            </button>
                                            {formStatus === 'success' && (
                                                <span className="ms-3 text-success fade-in">{getText("Message sent!", "تم الإرسال!")}</span>
                                            )}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Support Section */}
            <section className="py-5">
                <div className="container py-4">

                    {/* Section Title */}
                    <div className="text-center mb-5 pb-4" data-aos="zoom-in">
                        <h2 className="fw-bold display-5 mb-3">
                            {lang === "en" ? "How Can We Help You?" : "كيف يمكننا مساعدتك؟"}
                        </h2>
                        <p className="text-muted fs-5">
                            {lang === "en"
                                ? "Choose the best way to reach our support team"
                                : "اختر أفضل طريقة للوصول إلى فريق الدعم لدينا"}
                        </p>
                    </div>

                    {/* Support Options */}
                    <div className="row g-4">

                        {/* Live Chat */}
                        <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="100">
                            <div className="h-100 p-4 bg-card text-center shadowP d-flex flex-column justify-content-between rounded-3">

                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10"
                                        style={{ width: 80, height: 80 }}>
                                        <i className="ri-message-3-line" style={{ fontSize: 40 }} />
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3">
                                    {lang === "en" ? "Live Chat" : "دردشة مباشرة"}
                                </h5>

                                <p className="text-muted mb-4">
                                    {lang === "en"
                                        ? "Get instant answers from our support team"
                                        : "احصل على إجابات فورية من فريق الدعم لدينا"}
                                </p>

                                <div className="mb-3">
                                    <small className="text-primary fw-bold">
                                        {lang === "en" ? "Available 24/7" : "متاح 24/7"}
                                    </small>
                                </div>

                                <a href="#" className="btn btn-outline-custom btn-sm w-100">
                                    {lang === "en" ? "Start Chat" : "ابدأ المحادثة"}
                                </a>
                            </div>
                        </div>

                        {/* Email Support */}
                        <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="200">
                            <div className="h-100 p-4 bg-card text-center shadowP d-flex flex-column justify-content-between rounded-3">

                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10"
                                        style={{ width: 80, height: 80 }}>
                                        <i className="ri-mail-send-line" style={{ fontSize: 40 }} />
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3">
                                    {lang === "en" ? "Email Support" : "الدعم عبر البريد"}
                                </h5>

                                <p className="text-muted mb-4">
                                    {lang === "en"
                                        ? "Send us detailed inquiries via email"
                                        : "أرسل لنا استفسارات مفصلة عبر البريد الإلكتروني"}
                                </p>

                                <div className="mb-3">
                                    <small className="text-primary fw-bold">
                                        {lang === "en" ? "Response in 24h" : "الرد خلال 24 ساعة"}
                                    </small>
                                </div>

                                <a href="mailto:support@innobridge.com" className="btn btn-outline-custom btn-sm w-100">
                                    {lang === "en" ? "Send Email" : "إرسال بريد"}
                                </a>
                            </div>
                        </div>

                        {/* Phone Support */}
                        <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="300">
                            <div className="h-100 p-4 bg-card text-center shadowP d-flex flex-column justify-content-between rounded-3">

                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10"
                                        style={{ width: 80, height: 80 }}>
                                        <i className="ri-phone-line" style={{ fontSize: 40 }} />
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3">
                                    {lang === "en" ? "Phone Support" : "الدعم الهاتفي"}
                                </h5>

                                <p className="text-muted mb-4">
                                    {lang === "en"
                                        ? "Speak directly with our experts"
                                        : "تحدث مباشرة مع خبرائنا"}
                                </p>

                                <div className="mb-3">
                                    <small className="text-primary fw-bold">
                                        {lang === "en" ? "Mon–Fri 9AM–6PM" : "الإثنين–الجمعة 9ص–6م"}
                                    </small>
                                </div>

                                <a href="tel:+12125550123" className="btn btn-outline-custom btn-sm w-100">
                                    {lang === "en" ? "Call Now" : "اتصل الآن"}
                                </a>
                            </div>
                        </div>

                        {/* Knowledge Base */}
                        <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="400">
                            <div className="h-100 p-4 bg-card text-center shadowP d-flex flex-column justify-content-between rounded-3">

                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10"
                                        style={{ width: 80, height: 80 }}>
                                        <i className="ri-book-open-line" style={{ fontSize: 40 }} />
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3">
                                    {lang === "en" ? "Knowledge Base" : "قاعدة المعرفة"}
                                </h5>

                                <p className="text-muted mb-4">
                                    {lang === "en"
                                        ? "Browse articles and find solutions"
                                        : "تصفح المقالات وابحث عن الحلول"}
                                </p>

                                <div className="mb-3">
                                    <small className="text-primary fw-bold">
                                        {lang === "en" ? "500+ Articles" : "أكثر من 500 مقال"}
                                    </small>
                                </div>

                                <a href="#" className="btn btn-outline-custom btn-sm w-100">
                                    {lang === "en" ? "Browse Articles" : "تصفح المقالات"}
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Quick Stats */}
                    <div className="row g-4 mt-4">

                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                            <div className="text-center p-4 bg-card shadowP rounded-3">
                                <h3 className="fw-bold text-primary mb-2">98%</h3>
                                <p className="text-muted mb-0">
                                    {lang === "en" ? "Customer Satisfaction" : "رضا العملاء"}
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
                            <div className="text-center p-4 bg-card shadowP rounded-3">
                                <h3 className="fw-bold text-primary mb-2">&lt;2h</h3>
                                <p className="text-muted mb-0">
                                    {lang === "en" ? "Average Response Time" : "متوسط وقت الاستجابة"}
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
                            <div className="text-center p-4 bg-card shadowP rounded-3">
                                <h3 className="fw-bold text-primary mb-2">24/7</h3>
                                <p className="text-muted mb-0">
                                    {lang === "en" ? "Support Availability" : "توفر الدعم"}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};
export default Contact;
